import React, { Component } from 'react';
import Select from 'react-select';
import { HandleSubmit } from '../../func/HandleSubmit';
import ReactToPrint from "react-to-print";
import ReactTable from 'react-table-6'
import "react-table-6/react-table.css";
import matchSorter from 'match-sorter';
import ProgressDetailView from '../Progress/ProgressDetailView';
const StatusNum = {
    prepishfactor: 5,
    pishfactor: 10,
    factor: 20,
    tahvil: 30,
    preafzayesh: 55,
    laghv: 40,
    afzayesh: 60,
}
let AnbarName = [];
let ProductName = [];
class ProgressDetailEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Loading: true,
            Action: "edit",
            Progress: this.props.progress,
            TableData: [],
            CommentData: {},
            SendParameters: { comment: { desc: "" } },

        };
        this.GetDataOfTable = this.GetDataOfTable.bind(this);
        this.GetKalaName = this.GetKalaName.bind(this);
        this.renderSelectEditable = this.renderSelectEditable.bind(this);
        this.renderQtyEditable = this.renderQtyEditable.bind(this);
        this.AddRow = this.AddRow.bind(this);
        this.RemRow = this.RemRow.bind(this);
        this.Reset = this.Reset.bind(this);
        this.HandleRegister = this.HandleRegister.bind(this);
    }

    async GetDataOfTable() {
        const params = {
            request_code: this.props.request_code,
            progress: this.state.Progress,
            //            nextprogress: this.props.nextprogress
        }
        const response_info = await HandleSubmit('getdata/getdetailofrequest', params);
        this.state.TableData = (response_info.progress_row);
        this.state.CommentData = JSON.parse(response_info.progress_comment);
        this.setState({
            TableData: this.state.TableData,
            CommentData: this.state.CommentData,
            Loading: false
        });
    }
    ValidatingForm() {
        if (this.state.TableData.length < 1)
            return false;
        const re = /^[0-9\b]+$/;
        for (let item of this.state.TableData) {
            if (item['kala_code'].trim() == "")
                return false;
            if (re.test(item['qty_value'].trim()) == false)
                return false;
            if (this.state.Progress == StatusNum.afzayesh || this.state.Progress == StatusNum.tahvil)
                if (item['anbar_code'].trim() == "" || item['anbar_code'].trim() == "0")
                    return false;
        }
        return true;
    }
    async HandleRegister() {
        console.log("sens", this.state.SendParameters);
        if (this.ValidatingForm() == false)
            return false;
        this.state.SendParameters['request_code'] = this.props.request_code;
        this.state.SendParameters['progress'] = this.state.Progress;
        this.state.SendParameters['action'] = this.state.Action;
        this.state.SendParameters['detail'] = this.state.TableData;
        this.setState({
            Loading: true,
            SendParameters: this.state.SendParameters
        });
        let url = 'confirm/confirmrequest';
        var response_info = await HandleSubmit(url, this.state.SendParameters);
        if (response_info.status === "OK" && response_info.request_code > 0) {
            this.setState({
                Loading: false,
                Action: "view"
            });
        }
        else if (response_info.status === "InvError") {
            alert("مشکل در موجودی");
        }
        else {
            alert("مشکل در ثبت");
        }
    }
    async componentDidMount() {
        this.setState({
            Loading: true
        });
        await this.GetKalaName();
        await this.GetAnbarName();
        await this.GetDataOfTable();
        this.setState({
            Loading: false
        });
    }
    async Reset() {
        await this.GetDataOfTable();
    }
    AddRow() {
        const row = {
            anbar_code: "", anbar_name: "", kala_code: "",
            kala_inventory: "", kala_name: "", qty_value: "", row: this.state.TableData.length
        };
        this.state.TableData.push(row);
        this.setState({ TableData: this.state.TableData });
    }
    async RemRow(index) {
        this.state.TableData.splice(index, 1);
        this.setState({ TableData: this.state.TableData });
    }
    async GetKalaName() {
        var response_info = await HandleSubmit('getdata/getkalaname', '');
        ProductName = response_info;
    }
    async GetAnbarName() {
        // console.log("ppp: ", this.state.Anbar);
        var response_info = await HandleSubmit('getdata/getanbarname', '');
        AnbarName = response_info;
    }
    handleInputChange = (cellInfo, event) => {
        this.state.TableData[cellInfo.index][cellInfo.column.id] = event.target.value;
        this.setState({ TableData: this.state.TableData });
    }
    handleSelectChange = (cellInfo, value, col_name) => {
        this.state.TableData[cellInfo.index][cellInfo.column.id] = value.label;
        this.state.TableData[cellInfo.index][col_name] = value.value;
        this.setState({ TableData: this.state.TableData });
    }
    renderQtyEditable = cellInfo => {
        const cellValue = this.state.TableData[cellInfo.index][cellInfo.column.id];
        const re = /^[0-9\b]+$/;
        let ErrorMsg = ((cellValue.trim()) == "" || re.test(cellValue.trim()) == false) ? "باید عدد باشد" : "";
        return (
            <React.Fragment>
                <input
                    placeholder="type here"
                    name="input"
                    type="text"
                    onChange={(e) => this.handleInputChange(cellInfo, e)}
                    value={cellValue}
                />
                <br /> <span>{ErrorMsg}</span>
            </React.Fragment>
        );
    }
    renderSelectEditable = (options, cellInfo, col_name) => {
        let cellLabel = this.state.TableData[cellInfo.index][cellInfo.column.id];
        let cellValue = this.state.TableData[cellInfo.index][col_name];
        let ErrorMsg = ((cellValue.trim()) == "" || (cellValue.trim()) == "0") ? "نباید خالی باشد" : "";
        return (
            <React.Fragment>
                <Select
                    value={{ label: cellLabel, value: cellValue }}
                    options={options}
                    styles={{ menu: base => ({ ...base, position: 'relative' }) }}
                    onChange={(value) => this.handleSelectChange(cellInfo, value, col_name)}
                />
                <span>{ErrorMsg}</span>
            </React.Fragment>
        );
    };
    render() {
        if (this.state.Loading) { return "در حال بارگزاری..."; }
        if (this.state.Action === "view") {
            return <React.Fragment><ProgressDetailView progress={(this.state.Progress)} request_code={this.props.request_code} /></React.Fragment>
        }
        return (
            <div>
                {this.state.Action == "edit" ? "ویرایش" : null}
                {this.state.Action == "confirm" ? "تایید" : null}
                <div> شماره سفارش {this.props.request_code}</div>
                <React.Fragment>
                    <ReactTable
                        className="-striped -highlight"
                        showPagination={false}
                        minRows={0}
                        defaultPageSize={100}
                        headerStyle={{ fontWeight: "bold", fontcolor: "red" }}
                        data={this.state.TableData}
                        columns={[
                            {
                                Header: "#",
                                accessor: "row",
                                maxWidth: 100,
                                minWidth: 20,
                                Cell: (row) => (row.value + 1)
                            },
                            {
                                Header: () => <div style={{ fontWeight: "bold" }}> نام کالا </div>,
                                accessor: "kala_name",
                                maxWidth: 400,
                                minWidth: 200,
                                Cell: (row) => this.renderSelectEditable(ProductName, row, 'kala_code'),
                                style: { overflow: 'visible' },
                            },
                            {
                                Header: () => <div style={{ fontWeight: "bold" }}>انبار </div>,
                                accessor: "anbar_name",
                                maxWidth: 250,
                                minWidth: 200,
                                Cell: (row) => this.renderSelectEditable(AnbarName, row, 'anbar_code'),
                                style: { overflow: 'visible' },
                                show: (this.state.Progress != StatusNum.afzayesh && this.state.Progress != StatusNum.tahvil) ? false : true,
                            },
                            {
                                Header: () => <div style={{ fontWeight: "bold" }}>تعداد </div>,
                                accessor: "qty_value",
                                Cell: (cellinfo) => this.renderQtyEditable(cellinfo),
                            },
                            {
                                Header: () => <div style={{ fontWeight: "bold" }}> </div>,
                                accessor: "",
                                Cell: (cellinfo) => <button className="btn btn-outline-danger" onClick={() => this.RemRow(cellinfo.index)}>حذف</button>
                            }

                        ]}
                        className="-striped -highlight"
                    />
                </React.Fragment>
                <br />
                {(this.state.Loading) ? null :
                    <React.Fragment>
                        <table>
                            <tr>
                                <td><button className="btn btn-success" onClick={() => this.AddRow()}>+</button></td>
                                <td><button className="btn btn-success" onClick={() => this.HandleRegister()}>تایید</button></td>
                                <td><button className="btn btn-success" onClick={() => this.Reset()}>Reset</button></td>
                            </tr>
                            <tr >
                                <td style={{ "textAlign": "left" }}>توضیحات</td>
                                <td colSpan="2" style={{ "textAlign": "right" }}>
                                    <textarea rows="3" cols="30" name="description"
                                        onChange={(e) => (
                                            this.state.SendParameters['comment']['desc'] = e.target.value,
                                            this.setState(
                                                {
                                                    SendParameters: this.state.SendParameters
                                                }
                                            ))}
                                        defaultValue={this.state.SendParameters['comment']['desc']}
                                    />
                                </td>
                            </tr>
                            {(this.state.Progress) == StatusNum.tahvil ?
                                <tr>
                                    <td style={{ "textAlign": "left" }}> نام راننده</td>
                                    <td colSpan="2" style={{ "textAlign": "right" }}>
                                        <input type="text"
                                            onChange={(e) => (
                                                this.state.SendParameters = {
                                                    comment: { driver_name: e.target.value }
                                                },
                                                this.setState(
                                                    {
                                                        SendParameters: this.state.SendParameters
                                                    }
                                                ))}

                                            defaultValue={this.state.CommentData.driver_name != null ? this.state.CommentData.driver_name : ""}
                                        />
                                    </td>
                                </tr>
                                : null}
                        </table>
                    </React.Fragment>}
            </div >
        );
    }

}
export default (ProgressDetailEdit);



// WEBPACK FOOTER //
// ./src/pages/Progress/ProgressDetailEdit.js